class ClaroluzNoOffers {
    constructor() {
        this.init();
    }

    private init() {
        document.querySelector('.claroluz-nooffers-container')?.classList.remove('display-none');
        document.querySelector('.claroluz-offers-container')?.classList.add('display-none');
    }
}